'use client';
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import {Filter, Grid2X2} from "lucide-react";
import Category from "@/app/ui/catalog/category";
import FilterItems from "@/app/ui/filterItems";

/** @param {{ section: any, selectedCount?: number, triggerClassName?: string, categoryInfo?: any, categoryList?: any[] }} props */
export default function FilterMob({
    section,
    selectedCount = 0,
    triggerClassName = '',
    categoryInfo = null,
    categoryList = [],
}) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="flex flex-col gap-2">
            <Button
                onClick={() => setIsOpen(true)}
                className={`flex items-center justify-between rounded-full px-4 py-2 bg-gray-100 text-sm font-semibold ${triggerClassName}`}
                variant="outline"
            >
                <span className="flex items-center gap-2">
                    <Filter className="size-4" />
                    <span>Фильтры</span>
                </span>
                {selectedCount > 0 && (
                    <span className="ml-2 inline-flex min-w-5 items-center justify-center rounded-full bg-red-500 text-xs font-medium text-white px-1.5 py-0.5">
                        {selectedCount}
                    </span>
                )}
            </Button>

            <Dialog open={isOpen} onOpenChange={setIsOpen}>
                <DialogContent className="max-h-[90vh] overflow-y-auto">
                    <DialogHeader>
                        <DialogTitle>Фильтр</DialogTitle>
                    </DialogHeader>
                    <div>
                        {categoryInfo && Array.isArray(categoryList) && categoryList.length > 0 && (
                            <div className="space-y-3">
                                <div className="flex items-center justify-between text-sm font-semibold uppercase text-gray-500">
                                    <span>Категории</span>
                                    <Grid2X2 className="size-4 text-gray-400"/>
                                </div>
                                <div className="max-h-72 overflow-y-auto rounded-lg border border-gray-200 bg-gray-50 p-2">
                                    <Category catInfo={categoryInfo} allCatSection={categoryList || []}/>
                                </div>
                                <hr className="shrink-0 border-none w-full h-px bg-gray-100" role="separator"/>
                            </div>
                        )}

                        <div className="flex items-center justify-between text-lg font-medium">
                            <span>Фильтры</span>
                            <Filter className="size-5"/>
                        </div>

                        <FilterItems section={section}/>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
